import { format } from 'date-fns'

export default function dateToTime(date) {
  if(!date) {
    return null
  }
  return format(date, 'hh:mm aa')
}
